import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "header-btn-wrap"
  }, [_c("cpsc-file-upload", {
    staticClass: "btn",
    attrs: {
      "show-list": false,
      clear: true,
      accept: ".xlsx,.xls",
      multiple: true,
      "btn-text": "顺丰速打模板点击上传(可多选)"
    },
    on: {
      change: _vm.fileChange
    }
  }), _c("cpsc-file-upload", {
    staticClass: "btn",
    attrs: {
      "show-list": false,
      clear: true,
      accept: ".xlsx,.xls",
      multiple: true,
      type: "success",
      "btn-text": "顺发打单模板点击上传(可多选)"
    },
    on: {
      change: _vm.fileChange2
    }
  })], 1), _c("el-collapse", {
    staticClass: "collapse",
    model: {
      value: _vm.activeNames,
      callback: function callback($$v) {
        _vm.activeNames = $$v;
      },
      expression: "activeNames"
    }
  }, [_c("el-collapse-item", {
    attrs: {
      title: "默认带入的数据",
      name: "1"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" 默认带入的数据"), _c("span", {
    staticClass: "collapse-tips"
  }, [_vm._v("(首次使用请完善相关信息, 下次将默认带入; 可随时按需修改并作为下次使用的默认数据; 必须点击同步按钮才能带入填写的数据)")])]), _c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.model,
      size: "mini",
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "发函方式"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      size: "mini",
      filterable: "",
      placeholder: "请选择发函方式"
    },
    model: {
      value: _vm.model.c02SendType,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c02SendType", $$v);
      },
      expression: "model.c02SendType"
    }
  }, _vm._l(_vm.correspondenceTypes, function (item) {
    return _c("el-option", {
      key: item.n04Id,
      attrs: {
        label: item.n04Value,
        value: item.n04Value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "函证发出点"
    }
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      size: "mini",
      placeholder: "所内、项目驻地酒店、电邮、传真号、网站等"
    },
    model: {
      value: _vm.model.c02SendAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c02SendAddress", $$v);
      },
      expression: "model.c02SendAddress"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "发函日期"
    }
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      clearable: "",
      size: "mini",
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择发函/跟函日期"
    },
    model: {
      value: _vm.model.c02SendDate,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c02SendDate", $$v);
      },
      expression: "model.c02SendDate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "发函记录"
    }
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      size: "mini",
      placeholder: "发函记录"
    },
    model: {
      value: _vm.model.c02SendProcess,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c02SendProcess", $$v);
      },
      expression: "model.c02SendProcess"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "快递公司"
    }
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      data: _vm.sendCompany,
      "is-filter": true,
      "filter-name": "text",
      "filter-code": "code",
      clearable: "",
      size: "mini",
      "default-data-items": _vm.defaultDataItems,
      placeholder: "请选择快递公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var data = _ref.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.code,
            attrs: {
              label: item.text,
              value: item.text
            }
          });
        });
      }
    }]),
    model: {
      value: _vm.model.c02SendCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "c02SendCompany", $$v);
      },
      expression: "model.c02SendCompany"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "success"
    },
    on: {
      click: _vm.updateTableData
    }
  }, [_vm._v("同步")])], 1)], 2)], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      size: "mini",
      border: "",
      "max-height": "680",
      "cell-class-name": _vm.cellClassName
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      fixed: "left",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "c02ConfirmCode",
      label: "函证编号",
      fixed: "left",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.c02ConfirmCode))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendNumber",
      width: "140",
      label: "快递单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: "请输入快递单号"
          },
          model: {
            value: scope.row.c02SendNumber,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendNumber", $$v);
            },
            expression: "scope.row.c02SendNumber"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendCompany",
      width: "140",
      label: "快递公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("cpsc-select", {
          staticClass: "select",
          attrs: {
            filterable: "",
            data: _vm.sendCompany,
            "is-filter": true,
            "filter-name": "text",
            "filter-code": "code",
            clearable: "",
            size: "mini",
            "default-data-items": _vm.defaultDataItems,
            placeholder: "请选择快递公司"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var data = _ref2.data;
              return _vm._l(data, function (item) {
                return _c("el-option", {
                  key: item.code,
                  attrs: {
                    label: item.text,
                    value: item.text
                  }
                });
              });
            }
          }], null, true),
          model: {
            value: scope.row.c02SendCompany,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendCompany", $$v);
            },
            expression: "scope.row.c02SendCompany"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendFee",
      width: "110",
      label: "发函费用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input-number", {
          staticClass: "app-form-component-select",
          attrs: {
            "controls-position": "right",
            size: "mini",
            min: 0,
            max: 9999,
            label: "请输入发函费用"
          },
          on: {
            change: function change(val) {
              return _vm.handleFeeChange(val, scope.row);
            }
          },
          model: {
            value: scope.row.c02SendFee,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendFee", $$v);
            },
            expression: "scope.row.c02SendFee"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendType",
      label: "发函方式",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("cpsc-select", {
          staticClass: "select",
          attrs: {
            size: "mini",
            filterable: "",
            placeholder: "请选择发函方式"
          },
          model: {
            value: scope.row.c02SendType,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendType", $$v);
            },
            expression: "scope.row.c02SendType"
          }
        }, _vm._l(_vm.correspondenceTypes, function (item) {
          return _c("el-option", {
            key: item.n04Id,
            attrs: {
              label: item.n04Value,
              value: item.n04Value
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendAddress",
      width: "160",
      label: "函证发出点"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: "所内、项目驻地酒店、电邮、传真号、网站等"
          },
          model: {
            value: scope.row.c02SendAddress,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendAddress", $$v);
            },
            expression: "scope.row.c02SendAddress"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendDate",
      width: "150",
      label: "发函日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-date-picker", {
          staticClass: "app-form-component-select",
          attrs: {
            type: "date",
            clearable: "",
            size: "mini",
            "value-format": "yyyy-MM-dd",
            placeholder: "请选择发函/跟函日期"
          },
          model: {
            value: scope.row.c02SendDate,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendDate", $$v);
            },
            expression: "scope.row.c02SendDate"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendProcess",
      width: "135",
      label: "发函记录"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          staticClass: "app-form-component-select",
          attrs: {
            size: "mini",
            placeholder: "发函记录"
          },
          model: {
            value: scope.row.c02SendProcess,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendProcess", $$v);
            },
            expression: "scope.row.c02SendProcess"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendBelong",
      width: "130",
      label: "发函所属"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("cpsc-select", {
          staticClass: "select",
          attrs: {
            filterable: "",
            clearable: "",
            size: "mini",
            placeholder: "请选择费用所属"
          },
          model: {
            value: scope.row.c02SendBelong,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendBelong", $$v);
            },
            expression: "scope.row.c02SendBelong"
          }
        }, _vm._l(_vm.costTypes, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              label: item.name,
              value: item.value
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "c02SendFeeStatus",
      width: "130",
      label: "费用回收状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("cpsc-select", {
          staticClass: "select",
          attrs: {
            filterable: "",
            clearable: "",
            size: "mini",
            placeholder: "请选择费用回收状态"
          },
          model: {
            value: scope.row.c02SendFeeStatus,
            callback: function callback($$v) {
              _vm.$set(scope.row, "c02SendFeeStatus", $$v);
            },
            expression: "scope.row.c02SendFeeStatus"
          }
        }, _vm._l(_vm.costStates, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              label: item.name,
              value: item.value
            }
          });
        }), 1)];
      }
    }])
  })], 1), _vm.errorCodes ? _c("el-alert", {
    staticClass: "alert",
    attrs: {
      title: "下列函证编码录入错误",
      description: _vm.errorCodes,
      type: "warning"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "success",
      size: "mini",
      disabled: _vm.tableData.length === 0,
      loading: _vm.loading
    },
    on: {
      click: function click($event) {
        return _vm.submit(false);
      }
    }
  }, [_vm._v("保存发函信息")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      disabled: _vm.tableData.length === 0,
      loading: _vm.loading
    },
    on: {
      click: function click($event) {
        return _vm.submit(true);
      }
    }
  }, [_vm._v("保存并置为已发")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };